"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALID_MEDIA_PROCESSORS = exports.MEDIA_PROCESSORS = exports.WEBM = exports.MP4 = exports.JPEG = exports.GIF = exports.CHUNK_INDEX_TOKEN = exports.VIDEO_TRANSFORM_TYPE = exports.DEFAULT_MEDIA_VARIANT_KEYFRAME_INTERVAL = void 0;
var DEFAULT_MEDIA_VARIANT_KEYFRAME_INTERVAL = 3;
exports.DEFAULT_MEDIA_VARIANT_KEYFRAME_INTERVAL = DEFAULT_MEDIA_VARIANT_KEYFRAME_INTERVAL;
var VIDEO_TRANSFORM_TYPE = {
  CHUNK: 'chunk',
  TRANSCODE: 'transcode'
}; // frame-extraction specific constants

exports.VIDEO_TRANSFORM_TYPE = VIDEO_TRANSFORM_TYPE;
var CHUNK_INDEX_TOKEN = '((chunkIndex))'; // mime types

exports.CHUNK_INDEX_TOKEN = CHUNK_INDEX_TOKEN;
var GIF = 'image/gif';
exports.GIF = GIF;
var JPEG = 'image/jpeg';
exports.JPEG = JPEG;
var MP4 = 'video/mp4';
exports.MP4 = MP4;
var WEBM = 'video/webm';
exports.WEBM = WEBM;
var MEDIA_PROCESSORS = {
  MDP: 'MDP',
  VIS: 'VIS'
};
exports.MEDIA_PROCESSORS = MEDIA_PROCESSORS;
var VALID_MEDIA_PROCESSORS = new Set(Object.keys(MEDIA_PROCESSORS));
exports.VALID_MEDIA_PROCESSORS = VALID_MEDIA_PROCESSORS;